// extracted by mini-css-extract-plugin
export default {"Box":"delete-field-dialog-module__Box--NmqeB","Text":"delete-field-dialog-module__Text--Tgtul"};